import { admin, type AdminStandardItem } from '../../lib/api';
import { useApi } from '../../hooks/useApi';
import { DataTable, type Column } from '../../components/ui';
import { useAdminT } from './adminI18n';

export default function AdminStandardsPage() {
  const t = useAdminT();
  const q = useApi(() => admin.standards(), []);
  const rows = q.status === 'success' ? q.data : [];

  const columns: Column<AdminStandardItem>[] = [
    { key: 'name', header: t('col.name'), render: (r) => r.name },
    { key: 'primary_standard', header: t('std.primary'), width: '140px', mono: true,
      render: (r) => r.primary_standard },
    { key: 'score_report_format', header: t('std.report'), width: '140px', mono: true,
      render: (r) => r.score_report_format },
    { key: 'is_default', header: t('cprof.default'), width: '70px', render: (r) => (r.is_default ? '★' : '—') },
    { key: 'is_system', header: t('cprof.system'), width: '80px', render: (r) => (r.is_system ? '✓' : '—') },
  ];

  return (
    <div className="admin-page">
      <header className="admin-page__head">
        <h1>{t('std.title')}</h1>
        <p className="admin-page__sub">{t('std.subtitle')}</p>
      </header>
      <DataTable columns={columns} rows={rows} rowKey={(r) => r.id}
        loading={q.status === 'loading'} empty={t('emptyGeneric')} />
    </div>
  );
}
